export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: "看番时一直卡顿怎么办?",
    answer:
      "在小猴看番播放页点击「切换线路」,选择备用线路或开启「自动选源」。系统会综合检测各线路的响应速度与稳定性,自动为你匹配当前网络下最流畅的播放源,无需刷新页面即可继续观看。",
  },
  {
    question: "如何手动秒切线路?",
    answer:
      "播放器下方会清晰展示当前番剧的全部可用线路,点击任意一条即可立即切换,切换过程无需刷新页面,且播放进度可自动续播,真正做到秒切不断档。",
  },
  {
    question: "什么是备用线路?",
    answer:
      "备用线路是当主线路出现卡顿、失效或高峰拥堵时,可随时一键切换的额外播放源。小猴看番为每部番剧都准备了多条备用线路,保证你追更途中不中断。",
  },
  {
    question: "自动选源是如何工作的?",
    answer:
      "开播时系统会并行检测各线路的加载速度、稳定性和画质,自动选择当前最合适的播放源,同时保留手动切换入口,让你既省心又能随时掌控播放体验。",
  },
  {
    question: "热门新番和经典老番都能看吗?",
    answer:
      "可以的。小猴看番聚合了热门新番、经典老番、国漫精选与剧场版等丰富内容,所有番剧均支持多线路播放,任何类别都能快速找到可播线路。",
  },
  {
    question: "切换线路后播放进度会丢失吗?",
    answer:
      "不会。秒切线路时会自动记录当前播放进度,切换完成后可无缝续播,让你从上次中断的位置继续观看,追更体验更省心。",
  },
];

export interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
  accent: "primary" | "accent" | "secondary";
}

export const featureList: FeatureItem[] = [
  {
    icon: "ri-settings-3-line",
    title: "自动选源",
    desc: "开播智能检测各线路速度与稳定性,自动匹配当前网络下最流畅的播放源。",
    accent: "primary",
  },
  {
    icon: "ri-flashlight-line",
    title: "秒切线路",
    desc: "点击即可立即切换播放线路,无需刷新页面,播放进度自动无缝续播。",
    accent: "accent",
  },
  {
    icon: "ri-stack-line",
    title: "多源播放",
    desc: "每部番剧聚合多条播放源,画质与速度自由选择,总有一条适合你。",
    accent: "secondary",
  },
  {
    icon: "ri-lifebuoy-line",
    title: "备用线路",
    desc: "主线路卡顿或失效时,备用线路随时待命,一键切换追更不中断。",
    accent: "accent",
  },
  {
    icon: "ri-tools-line",
    title: "卡顿修复",
    desc: "聚合多线路解决看番卡顿问题,高峰时段也能找到稳定可播线路。",
    accent: "primary",
  },
  {
    icon: "ri-refresh-line",
    title: "稳定追更",
    desc: "热门新番老番实时同步,多线路保障,让你安心追更不掉链子。",
    accent: "secondary",
  },
];

export interface GuideStep {
  num: string;
  title: string;
  desc: string;
  icon: string;
}

export const guideSteps: GuideStep[] = [
  {
    num: "01",
    title: "打开播放页",
    desc: "在小猴看番选择任意番剧进入播放页面,顶部会展示当前自动选择的线路。",
    icon: "ri-play-circle-line",
  },
  {
    num: "02",
    title: "开启自动选源",
    desc: "开启「自动选源」开关,系统将自动为你检测并匹配最流畅的线路。",
    icon: "ri-magic-line",
  },
  {
    num: "03",
    title: "手动秒切线路",
    desc: "若感觉卡顿,点击播放器下方的线路栏,任选一条备用线路即可秒切切换。",
    icon: "ri-switch-line",
  },
  {
    num: "04",
    title: "无缝续播追更",
    desc: "切换完成后播放进度自动续播,多源播放稳定,放心畅快追更。",
    icon: "ri-flag-line",
  },
];

export interface StatItem {
  value: string;
  label: string;
}

export const statList: StatItem[] = [
  { value: "1200+", label: "聚合播放源" },
  { value: "5800+", label: "覆盖番剧" },
  { value: "4", label: "精选内容分区" },
  { value: "99.2%", label: "线路可用率" },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  color: string;
}

export const testimonialList: Testimonial[] = [
  {
    name: "阿楠",
    role: "追更党",
    text: "以前一到晚高峰就卡成PPT,现在开了自动选源,热播新番一路顺畅,再也不用半夜爬起来看了。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    name: "小满",
    role: "老番收藏家",
    text: "小猴的备用线路是真香,主线路一卡,点一下秒切,播放进度还自动续上,体验拉满。",
    color: "bg-accent-100 text-accent-700",
  },
  {
    name: "老K",
    role: "国漫爱好者",
    text: "国漫分区做得又全又稳,高清多源随便选,周末一天能刷完一整部,太爽了。",
    color: "bg-secondary-100 text-secondary-900",
  },
];